<template>
    <a-modal :title="$t('program.export_program' /* 导出日程 */)" :width="600" :maskClosable="false" :visible="visible" @cancel="handleModalClose">
        <a-form :form="form">
            <a-form-item :label="$t('program.select_export_date' /* 选择导出日期 */)">
                <a-select :placeholder="$t('formConfig.please_select' /* 请选择 */)" v-decorator="['meeting_date']">
                    <a-select-option v-for="item in dateList" :key="item.id" :value="item.id">
                        {{ item.meeting_date }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item :label="$t('program.select_export_hall' /* 选择导出会场 */)">
                <a-select :placeholder="$t('formConfig.please_select' /* 请选择 */)" v-decorator="['hall_id']">
                    <a-select-option v-for="item in hallList" :key="item.id" :value="item.id">
                        {{ item.meeting_hall }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item :label="$t('program.select_export_special_forum' /* 选择导出专题分论坛 */)">
                <a-select :placeholder="$t('formConfig.please_select' /* 请选择 */)" v-decorator="['class_id']">
                    <a-select-option v-for="item in xuezuList" :key="item.id" :value="item.id">
                        {{ item.class_cnname }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-row>
                <a-col :xs="24" :sm="12" :md="12">
                    <a-form-item :label="$t('program.show_host_unit' /* 是否显示主持人单位 */)">
                        <a-radio-group name="is_org_cnname" v-decorator="['is_org_cnname', { initialValue: 0 }]">
                            <a-radio :value="1">{{ $t('formConfig.yes' /* 是 */) }}</a-radio>
                            <a-radio :value="0">{{ $t('formConfig.no' /* 否 */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="12" :md="12">
                    <a-form-item :label="$t('program.show_speaker_unit' /* 是否显示发言人单位 */)">
                        <a-radio-group name="is_fyr_org_cnname" v-decorator="['is_fyr_org_cnname', { initialValue: 1 }]">
                            <a-radio :value="1">{{ $t('formConfig.yes' /* 是 */) }}</a-radio>
                            <a-radio :value="0">{{ $t('formConfig.no' /* 否 */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="12" :md="12">
                    <a-form-item :label="$t('program.show_speech_type' /* 是否显示发言类型 */)">
                        <a-radio-group name="is_fy_type" v-decorator="['is_fy_type', { initialValue: 0 }]">
                            <a-radio :value="1">{{ $t('formConfig.yes' /* 是 */) }}</a-radio>
                            <a-radio :value="0">{{ $t('formConfig.no' /* 否 */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="12" :md="12">
                    <a-form-item :label="$t('program.show_country' /* 是否显示国别 */)">
                        <a-radio-group name="is_country" v-decorator="['is_country', { initialValue: 0 }]">
                            <a-radio :value="1">{{ $t('formConfig.yes' /* 是 */) }}</a-radio>
                            <a-radio :value="0">{{ $t('formConfig.no' /* 否 */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item :label="$t('program.show_chinese_english' /* 是否显示中英文 */)">
                        <a-radio-group name="is_ce_language" v-decorator="['is_ce_language', { initialValue: 'cn' }]">
                            <a-radio value="all">{{ $t('program.show_all' /* 全部展示 */) }}</a-radio>
                            <a-radio value="cn">{{ $t('program.show_chinese_only' /* 只展示中文 */) }}</a-radio>
                            <a-radio value="en">{{ $t('program.show_english_only' /* 只展示英文 */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item :label="$t('program.show_paper_number' /* 是否显示论文编号 */)">
                        <a-radio-group name="show_no_type" v-decorator="['show_no_type', { initialValue: 0 }]">
                            <a-radio :value="0">{{ $t('formConfig.no' /* 否 */) }}</a-radio>
                            <a-radio :value="1">{{ $t('program.show_paper_number_text' /* 显示论文编号 */) }}</a-radio>
                            <a-radio :value="2">{{ $t('program.show_serial_number' /* 显示序号 */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
                <a-col :xs="24" :sm="12" :md="12">
                    <a-form-item :label="$t('program.show_hidden_schedule' /* 是否显示隐藏日程 */)">
                        <a-radio-group name="is_display_program" v-decorator="['is_display_program', { initialValue: 1 }]">
                            <a-radio :value="1">{{ $t('formConfig.yes' /* 是 */) }}</a-radio>
                            <a-radio :value="0">{{ $t('formConfig.no' /* 否 */) }}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
        <template slot="footer">
            <a-button type="primary" @click="handleExportEvent('word')">{{ $t('program.export_program_word' /* 导出日程Word版 */) }}</a-button>
            <a-button type="primary" @click="handleExportEvent('excel')">{{ $t('program.export_program_excel' /* 导出日程Excel版 */) }}</a-button>
        </template>
    </a-modal>
</template>

<script>
const fileds = ['meeting_date', 'hall_id', 'class_id', 'is_org_cnname', 'is_fyr_org_cnname', 'is_fy_type', 'is_ce_language', 'is_country', 'show_no_type', 'is_display_program'];

export default {
    name: 'ExportPragramDrawer',
    props: {
        xuezuList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        dateList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        hallList: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    components: {},
    data() {
        return {
            visible: false,
            form: this.$form.createForm(this)
        };
    },
    computed: {},
    methods: {
        show() {
            this.visible = true;
        },
        //关闭弹窗
        handleModalClose() {
            this.form.resetFields();
            this.visible = false;
        },
        /**
         * ## 导出日程
         * @param type
         */
        handleExportEvent(type) {
            let { domain } = this.$store.state.meetingInfo;
            let baseUrl = type == 'word' ? domain + '/program/operation/export-program-word/' : domain + '/program/operation/export-program-excel/';
            let queryArr = [];
            for (let key in this.form.getFieldsValue()) {
                const value = this.form.getFieldsValue()[key];
                queryArr.push(`${key}=${value !== undefined ? value : ''}`);
            }
            let exportUrl = `${baseUrl}${this.$route.params.meeting_id}?${queryArr.join('&')}`;
            window.location.href = exportUrl;
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang='less' scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-modal-body {
    max-height: 72vh;
    overflow-y: auto;
}
</style>